import React from 'react';

import { Button, Colors } from '../../legacy/button/Button.component';
import styles from './OkModal.module.css';

interface Props {
  hideModal: () => void;
  text: string;
  onClick?: () => void;
  buttonText?: string;
}

interface OkModalProps {
  hideModal: () => void;
}

const OkModalContainer: React.FC<Props> = ({
  hideModal,
  text,
  onClick,
  buttonText = 'OK',
}: Props) => {
  return (
    <div className={styles.okModal}>
      <p className={styles.okText}>{text}</p>
      <Button
        color={Colors.COLOR_SCHEME_2}
        className={styles.okBtn}
        onClick={() => {
          if (onClick) {
            onClick();
          }
          hideModal();
        }}
      >
        {buttonText}
      </Button>
    </div>
  );
};

export const OkModal =
  (text: string, onClick?: () => void, buttonText?: string) =>
  ({ hideModal }: OkModalProps) => {
    return (
      <OkModalContainer
        text={text}
        hideModal={hideModal}
        onClick={onClick}
        buttonText={buttonText}
      />
    );
  };
